export function assertRuntimeEnv(): string | null {
  const missing: string[] = [];
  if (!import.meta.env.VITE_SUPABASE_URL) missing.push("VITE_SUPABASE_URL");
  if (!import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) missing.push("VITE_SUPABASE_PUBLISHABLE_KEY");
  if (!import.meta.env.VITE_SUPABASE_PROJECT_ID) missing.push("VITE_SUPABASE_PROJECT_ID");
  return missing.length ? missing.join(", ") : null;
}

export function renderConfigUnavailable(detail: string): void {
  const root = document.getElementById("root");
  if (!root) return;
  root.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;
                font-family:Inter,system-ui,sans-serif;padding:24px;text-align:center;color:#3b1f5b">
      <div style="max-width:480px">
        <h1 style="font-size:20px;margin:0 0 12px">Configuração indisponível</h1>
        <p style="margin:0 0 8px;color:#6b5b85">
          O aplicativo não pôde iniciar porque a configuração do backend não foi carregada neste build.
        </p>
        <p style="font-size:12px;color:#8a7aa5;margin:16px 0 0">
          Tente recarregar a página. Se o problema persistir, avise o suporte.
        </p>
        <p style="font-size:10px;color:#b9adcc;margin:24px 0 0">boot: ${detail}</p>
      </div>
    </div>`;
}
